export const basePaddingVertical = 8;
export const basePaddingHorizontal = 16;
export const basePadding = `${basePaddingVertical}px ${basePaddingHorizontal}px`;
export const compactBodyPadding = '10px';
